import List from "@/components/list";

const Table = (args) => {
  const { listeners } = args;
  const moveGroupUser = listeners["moveGroupUser"] || function () { };
  const setLeaderUser = listeners["setLeaderUser"] || function () { };
  const RCSelectionChange = listeners["selection-change"] || function () { };
  const changeRoom = listeners["changeRoom"] || function () { };
  const groupSourceType = args.props['groupSourceType'] || 1
  const isOnline = args.props['isOnline'] || 0
  const isParty = args.props['isParty'] || 1

  const Deal = ({ props: { vo } }) => {
    const item = vo.row;
    let flag = item.groupName === "未分组" || Number(groupSourceType) !== 1
    const dealConf = [
      ["ic-yidong-normal", "移动学员", () => moveGroupUser(item), ""],

    ];
    // if (Number(groupSourceType) === 1) {
    dealConf.push(
      [
        flag ? "icon-leaderUser-disable" : "icon-leaderUser",
        "设为组长",
        () => {
          if (flag) return
          setLeaderUser(item);
        },
      ],
    )
    // }
    dealConf.push(["iconfont icxiugaifangjianhao iconfont-adapt", "修改房间号", () => changeRoom(item), ""],);

    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip content={item[1]} placement="top">
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main",
    },
    {
      label: "所属小班",
      prop: "classChildName",
      width: "100",
      showOverflowTooltip: true,
    },
    {
      label: "所在分组",
      prop: "groupName",
      width: "100",
      showOverflowTooltip: true,
    },
    {
      label: "姓名",
      prop: "userName",
      width: "80",
      showOverflowTooltip: true,
    },
    {
      label: "组内职务",
      prop: "groupPost",
      width: "120",
      showOverflowTooltip: true,
    },
    {
      label: "工作单位",
      prop: "deptName",
      minWidth: "150",
      showOverflowTooltip: true,
    },
    {
      label: "单位及职务",
      prop: "unitPosition",
      minWidth: "150",
      showOverflowTooltip: true,
    },
    {
      label: "房间号",
      prop: "roomNumber",
      minWidth: "100",
      showOverflowTooltip: true,
    },
    {
      label: "职务层次",
      prop: "positionName",
      width: "100",
      showOverflowTooltip: true,
    },
    {
      label: "职级",
      prop: "positionLevelName",
      width: "100",
      showOverflowTooltip: true,
    },
    {
      label: "性别",
      prop: "sexName",
      width: "80",
      showOverflowTooltip: true,
    },
    {
      label: "出生年月",
      prop: "birthday",
      width: "80",
      showOverflowTooltip: true,
    },
    {
      label: "政治面貌",
      prop: "politicsName",
      width: "150",
      showOverflowTooltip: true,
    },
    {
      label: "学历",
      prop: "educationName",
      width: "120",
      showOverflowTooltip: true,
    },


  ];
  if (isOnline === 0 && isParty == 1 && groupSourceType == 1) {

    AccountTableConfig.push({
      label: "党校同步状态",
      prop: "groupPushStatusName",
      width: "100",
      showOverflowTooltip: true,
    })
    AccountTableConfig.push({
      label: "上次同步时间	",
      prop: "groupPushTime",
      width: "160",
      showOverflowTooltip: true,
    })
  }
  // if (groupSourceType === 1) {
  AccountTableConfig.push({
    label: "操作",
    fixed: "right",
    width: "100",
    render: (vo) => <Deal vo={vo} />,
  })
  // }
  return <List {...args} talbeCols={AccountTableConfig} onSelectionChange={RCSelectionChange} />;
};

export default Table;
